import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

import WatermarkRow from './WatermarkRow';
import { addWatermark } from '@modules/editor';

function WatermarkMenu() {
    const { t } = useTranslation();
    const watermarkList = useSelector((state: any) => state.editor.watermarkList);
    const dispatch = useDispatch();

    function addCard() {
        if (watermarkList.length < 5) {
            const newCard = {
                "type": "text",
                "text": `내용 ${watermarkList.length + 1}`,
                "image": "",
                "x": 100,
                "y": 100,
                "width": 200,
                "height": 200,
                "color": "#ffffff",
                "fontSize": 16
            };
            dispatch(addWatermark(newCard));
        }
    }

    return (
        <div className='watermark-menu'>
            <div className='menu-box'>
                {watermarkList.map((_: any, idx: number) => (
                    <WatermarkRow key={idx} idx={idx} />
                ))}

                {watermarkList.length < 5 && (
                    <IconButton className="add-button" onClick={addCard}>
                        <AddIcon />
                        <Typography variant="body1">{t('vod.manage.editor_tab.add_new_watermark')}</Typography>
                    </IconButton>
                )}
            </div>
        </div>
    );
}

export default WatermarkMenu;
